import gql from 'graphql-tag'

export const GET_ALL_PROVIDERS = gql`
  query GetAllProviders {
    providers {
      id, name, authKey, uniqueIdentifier, deletedAt , events {
        id, title
      }
    }
  }
`

export const CREATE_PROVIDER = gql`
  mutation CreateProvider($authKey: String!, $name: String!, $uniqueIdentifier: String!, $eventId: ID!) {
    createProvider(authKey: $authKey, name: $name, uniqueIdentifier: $uniqueIdentifier, eventId: $eventId)
  }
`

export const DELETE_PROVIDER = gql`
  mutation DeleteProvider($providerId: ID!) {
    deleteProvider(providerId: $providerId)
  }
`

export const RESTORE_PROVIDER = gql`
  mutation RestoreProvider($providerId: ID!) {
    restoreProvider(providerId: $providerId)
  }
`

export const UPDATE_PROVIDER = gql`
  mutation UpdateProvider($id: ID!, $authKey: String!, $name: String!, $uniqueIdentifier: String!, $eventIds: [ID!]!) {
    updateProvider(id: $id, authKey: $authKey, name: $name, uniqueIdentifier: $uniqueIdentifier, eventIds: $eventIds)
  }
`

export const GET_ALL_EVENTS = gql`
  query GetEventsProvider {
    getAllEvents {
      id, title
    }
  }`


